wbApp.directive('wbMaskedEdit', ['$timeout',
function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ctrl) {
            $timeout(function () {
                element.inputmask(attr.uiMask, {
                    "clearIncomplete": false,
                    "autoUnmask": true
                });
                if (!ctrl) return;

                ctrl.$render = function () {
                    element.val(ctrl.$viewValue || '');
                };

                element.on('keyup', function () {
                    scope.$apply(function () {

                        var isValid = element.inputmask("isComplete") || !element.val();
                        ctrl.$setValidity('mask', isValid);
                        if (isValid) {
                            ctrl.$setViewValue(element.val());
//                                element.inputmask('unmaskedvalue')
                            //);
                        }
                    });
                });

                element.on("$destroy", function () {
                    //element.unmask();
                });
            }, 1);
        }
    };
}]);